import React from "react";

import * as types from "types";
import ToolIcon from "assets/toolIcon.svg?react";
import Markdown from "../Markdown";
import CopyButton from "./CopyButton";
import styles from "./Message.module.scss";

// A little header message to add to tool result messages.
// TODO: could `content` ever be JSON? Would be nice to display it with syntax highlighting.
const toolResultTemplate = (
  content: types.Message["content"],
  toolCallId?: string
) => `**Tool call ID:** ${toolCallId}

**Content**:
\`\`\`txt
${content}
\`\`\``;

interface MessageToolResultProps {
  toolCallId: string;
  toolName: string;
  content: types.Message["content"];
}

/**
 * Represents a tool result message.
 * Usually tool results will be displayed with <MessageToolCall/> but it might
 * be possible to have a Tool Result message without a Tool Call message.
 * Memoized to avoid <ReactMarkdown /> running too often.
 */
export default React.memo(function MessageToolResult({
  toolCallId,
  toolName,
  content,
}: MessageToolResultProps) {
  const augmentedContent = `${toolResultTemplate(content, toolCallId)}`;
  const renderedContent = (
    <details>
      <summary>⚠ Orphan Tool Result: {toolName}</summary>
      <div className="mt3">
        <p className="lh-copy i">
          This tool result message has no corresponding tool call.
        </p>
        <Markdown content={augmentedContent} />
      </div>
    </details>
  );

  return (
    <div className={styles.messageContainer}>
      <span className={styles.messageRole}>Tool Result</span>
      <div className={styles.message}>
        {/* Display picture */}
        <div className={`${styles.displayPic} tool`}>
          <ToolIcon className={styles.toolIcon} />
        </div>
        {/* Role and message content */}
        <div className={`${styles.messageContent} tool`}>
          <CopyButton content={augmentedContent} />
          {renderedContent}
        </div>
        <div className={styles.avatarSpacer} aria-hidden="true" />
      </div>
    </div>
  );
});
